import { FC, PropsWithChildren } from 'react';
import { Headline, Stack } from '@servicetitan/design-system';

interface DetailsSectionProps extends PropsWithChildren {
    title: string;
}

export const DetailsSection: FC<DetailsSectionProps> = ({ title, children }) => {
    return (
        <Stack direction="column">
            <Headline className="m-b-3" size="small">
                {title}
            </Headline>
            {children}
        </Stack>
    );
};
